import React, { useState, useEffect } from 'react';
import { PayloadAction } from '@reduxjs/toolkit';
import { useWorker } from '@koale/useworker';

import { Grid } from '@mui/material';
import { Modal, Input, Button } from '../../../components';

import { Download as DownloadIcon } from '@mui/icons-material';

import {
  useSelector,
  useDispatch,
  notificationSlice,
  notificationsListSlice,
  fetchNotificationsVehicleIrregularitiesExportHTML
} from '../../../stores';

import {
  exportNotificationsVehicleIrregularitiesToHTML,
  handleApiDataNotificationsToHTML
} from '../table/exports/ExportNotificationsVehicleIrregularitiesToHTML';

const PLATE_MAX_LENGTH = 7;

export const NotificationVehicleIrregularitiesExportModal: React.FC = () => {
  const dispatch = useDispatch();

  const { notificationVehicleIrregularitiesExportModalIsOpen } = useSelector(state => state.notificationReducer);
  const filtersValues = useSelector(state => state.notificationsFiltersValuesReducer);

  const [plate, setPlate] = useState('');

  useEffect(() => {
    if (filtersValues.plate) {
      return setPlate(filtersValues.plate);
    }

    return setPlate('');
  }, [filtersValues.plate]);

  const [exportNotificationsToHTMLWorker] = useWorker(handleApiDataNotificationsToHTML);

  const handleExportHTML = () => {
    setPlate('');
    dispatch(notificationSlice.actions.toggleNotificationVehicleIrregularitiesExportModalIsOpen());

    dispatch(fetchNotificationsVehicleIrregularitiesExportHTML(plate)).then(
      (res: PayloadAction<any>) => {
        if (res.payload && res.payload.data) {
          exportNotificationsVehicleIrregularitiesToHTML(
            res.payload.data,
            dispatch,
            exportNotificationsToHTMLWorker
          ).then(() => {
            dispatch(notificationsListSlice.actions.closeExportModal());
          });
        } else dispatch(notificationsListSlice.actions.closeExportModal());
      }
    );
  }

  return (
    <Modal
      open={notificationVehicleIrregularitiesExportModalIsOpen}
      onClose={() => dispatch(notificationSlice.actions.toggleNotificationVehicleIrregularitiesExportModalIsOpen())}
      title='Relatório de irregularidades por veículo'
      width={600}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Input
            label='Placa'
            value={plate}
            inputProps={{ maxLength: PLATE_MAX_LENGTH }}
            onChange={value => setPlate(value.toUpperCase())}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth
            style={{ margin: 0 }}
            startIcon={<DownloadIcon />}
            variant='contained'
            label='Exportar'
            disabled={plate.length < PLATE_MAX_LENGTH}
            onClick={handleExportHTML}
          />
        </Grid>
      </Grid>
    </Modal>
  );
}